export default "__VITE_PUBLIC_ASSET__0caff864__"